import { useEffect, useState } from 'react';
import { audienceModeService } from '@/services/audienceModeService';
import type { AudienceModeSession } from '@/types/mediaOutlets';

export const useAudienceSession = (userId?: string, gameId?: string) => {
  const [activeSession, setActiveSession] = useState<AudienceModeSession | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userId && gameId) {
      loadActiveSession();
    } else {
      setLoading(false);
    }
  }, [userId, gameId]);

  const loadActiveSession = async () => {
    if (!userId || !gameId) return;
    
    setLoading(true);
    try {
      const session = await audienceModeService.getUserActiveSession(userId, gameId);
      setActiveSession(session);
    } catch (error) {
      console.error('Error loading active session:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshSession = () => {
    loadActiveSession();
  };

  return {
    activeSession,
    loading,
    refreshSession
  };
};
